export interface SettingsDefinitions {
  [key: string]: {
    type: "string" | "boolean";
    defaultValue: string | boolean | null;
  };
}

// UPDATE CODE HERE WHEN ADDING NEW SETTING (2)
export function getSettingDefinitions(iframe: boolean): SettingsDefinitions {
  return {
    idEmbed: { type: "string", defaultValue: null },

    backgroundColor: {
      type: "string",
      defaultValue: iframe ? "transparent" : "var(--surface-50)",
    },
    css: { type: "string", defaultValue: null },
    fontLink: {
      type: "string",
      defaultValue:
        "https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap",
    },
    fontFamily: { type: "string", defaultValue: "Ubuntu, Sans-serif" },
    departments: { type: "string", defaultValue: null },
    fontSize: { type: "string", defaultValue: "16px" },
    iframe_startPage: { type: "string", defaultValue: "jobs" },
    iframe_embedOrigin: { type: "string", defaultValue: null },
    iframe_pathBinding: { type: "string", defaultValue: null },
    locale: { type: "string", defaultValue: "nb" },
    iframe_overrideLocale: { type: "string", defaultValue: null }, //  not stored in db, set by loadCvpEmbedded
    logoJobFallback: { type: "string", defaultValue: null },
    logoPrimary: { type: "string", defaultValue: "DEFAULT_LOGO" },
    welcomePicture: { type: "string", defaultValue: "DEFAULT_WELCOME_PICTURE" },
    favicon: { type: "string", defaultValue: "DEFAULT_FAVICON" },
    primaryColor: { type: "string", defaultValue: "#5f3aa4" },
    theme: { type: "string", defaultValue: "lara-light-purple" },
    menu_extraLinks: { type: "string", defaultValue: null },

    app_enabled: { type: "boolean", defaultValue: false },
    jobview_prioAdrDepartment: { type: "boolean", defaultValue: false },
    jobview_prioFromDateText: { type: "boolean", defaultValue: true },
    jobview_showContactImage: { type: "boolean", defaultValue: false },
    jobview_showMunicipality: { type: "boolean", defaultValue: true },
    jobview_showNumCandidates: { type: "boolean", defaultValue: true },
    frontpage_showJoblist: { type: "boolean", defaultValue: true },
    frontpage_showWelcome: { type: "boolean", defaultValue: !iframe },
    iframe: { type: "boolean", defaultValue: true },
    iframe_joblist_showLoginButton: { type: "boolean", defaultValue: true },
    iframe_loginOldPortal: { type: "boolean", defaultValue: false },
    iframe_showCardMenu: { type: "boolean", defaultValue: true },
    profile_showNationality: { type: "boolean", defaultValue: false },
    profile_chooseKnowledgeLevel: { type: "boolean", defaultValue: false },
    timesheets_enabled: { type: "boolean", defaultValue: true },
    messages_enabled: { type: "boolean", defaultValue: true },
    jobview_enabled: { type: "boolean", defaultValue: true },
    workschedule_enabled: { type: "boolean", defaultValue: true },
    showTopBar: { type: "boolean", defaultValue: !iframe },
    showSidebar: { type: "boolean", defaultValue: !iframe },
  };
}
